// ESM-Huelle um lib/scripts/pos/CLS_CZVTBankomat.js (Phase 4, Welle 4c).
// Prototype-Stil bleibt vorerst.

// Strict-Mode-Fix (ESM): implizit zugewiesene Sloppy-Mode-Globals.
// "length" repariert dabei den TLV-Laengenparser (parseTLVInfo):
// im Classic-Modus verpuffte die Zuweisung still an der readonly
// window.length-Property - der Parser konnte nie funktionieren.
var voucher, messages, expr, length, rec_stat_code;
// ---------------------------------------------------------------------------
// CZVTBankomatHandlerHandler
//  Provides event handler routines for Bankomat terminal
// ---------------------------------------------------------------------------
function CZVTBankomatHandler() {
    this.requestNo = '';
    this.responseType = '';
    this.businessCase = '';
    this.messageText = '';
    this.Display = new CDisplay();
    this.previousResponse = '';
    //  this.bankomat = bankomat;
    /*    this.net = require('net');
     */
    this.Display = new CDisplay();
    this.host = POS.EnvProperties.BANKOMATTERMINALIP; //"192.168.100.139";
    this.port = POS.EnvProperties.BANKOMATTERMINALPORT; //"5577";
    //this.startServer();
    //  this.client = require('CLS_CRunClient.js');
    //      this.client = new CRunClient();
    //    this.client.init();

    if (POS.EnvProperties.DEBUGBK == "YES") {
        this.Debug = 1;
    } else {
        this.Debug = 0;
    }
    //    this.SerialPort = require("serialport").SerialPort;
    var status_information_codes = ["27:1:result-code", "04:6:payment-amount", "49:2:Currency Value: 09 78 = EUR", "0B:3:trace-number", "0C:3:time HHMMSS", "0D:2:date 2 byte MMDD",
        "29:4:terminal-ID", "22:LL:PAN", "87:2:receipt-number, 2 byte BCD packed. Valid only for non-Geldkarte transactions.", "3B:8:authorisation-attribute",
        "19:1:payment-type", "0E:2:expiry-date in Format YYMM", "8A:1:card-type (= ZVT card-type ID)", "8B:LL:card-name",
        "17:2:card sequence-number", "2A:15:contract-number for credit-cards, 15 byte, ASCII, not null-terminated.",
        "3C:LLL:additional text", "88:3:turnover-no", "06:TLV:additional-data", "60:LLL:end-of-day", "8C:1:card-type-ID of the network operator",
        "37:3:only for Reversal: Trace-number of the original payment;"
    ];
    this.status_codes = []; // new Array(status_information_codes.length);
    for (var i = 0; i < status_information_codes.length; i++) {
        var parts = status_information_codes[i].split(":");
        this.status_codes[Number('0x' + parts[0])] = parts;
    }
    var TLV = ["2F:payment type", "1F10:cardholder authentication", "1F12:card-technology"];
    this.TLV_container = [];
    for (var i = 0; i < TLV.length; i++) {
        var parts = TLV[i].split(":");
        this.TLV_container[Number('0x' + parts[0])] = parts;
    }
}

CZVTBankomatHandler.prototype.setAction = function (action, amount) {
    this.amount = amount;
    if (!action)
        action = "";
    this.action = action;
    this.transactionstatus = [];
}

CZVTBankomatHandler.prototype.registration = function () {

    var me = this;

    var nextStep = function () {
        if (me.port == 20008) {
            var buf = me.register(new Buffer([0x00, 0x00, 0x00]));
        } else {
            var buf = me.register(new Buffer([0x12, 0x34, 0x56]));
        }

        if (POS.Bankomat.Debug) {
            console.log("Send:");
            console.log(buf);
            log.add(1, "Info B-Kasse", 'Send Registrierungsdaten: ', buf.toString('hex'));
        }
        POS.Bankomat.timeoutId = setTimeout(
                function () {
                POS.Bankomat.timeout();
            }, 15000);
        me.client.sendWebsocketData(me.getDataRegister1, buf);
    }
    POS.hourGlass.show("Warte auf Daten vom Zahlterminal");
    this.client.sendWebsocketData(nextStep, "startpt");

}

CZVTBankomatHandler.prototype.timeout = function (args) { //timeout and other connection errors
    var me = POS.Bankomat;
    log.add(1, "Info B-Kasse", 'SendData: timeout', null);
    clearTimeout(POS.Bankomat.timeoutId);
    POS.hourGlass.hide();
    var messageText = "Kein Erfolg!";
    var extMessageText = messageText + " (timeout)";
    me.sendDisplayMessage(messageText);
    me.answerComp.onCancelTransaction(me.answerComp, messageText);
    me.client.sendWebsocketData(null, "endpt");
    //me.dump(extMessageText);
    var text = "Keine Verbindung zur Bankomat-Kasse oder Internet! Bitte Ansschlüsse prüfen und Bankomatkasse neu starten! Ist das nach nochmaligem Versuch erfolglos bitte mobile Bankomatkasse nehmen und Problem melden!";
    POS.message.show(text);
}

CZVTBankomatHandler.prototype.register = function (pwbuffer) {

    //EEE40048

    var buf = new Buffer([0x06, 0x00]);
    var configbyte = new Buffer([0x2]); //=00000010
    if (POS.Bankomat.action.indexOf('initial') == 0) {
        configbyte = new Buffer([0x0]); //=00000000
    }
    var servicebyte = new Buffer([0x03, 0x00]);
    var currencycode = new Buffer([0x09, 0x78]); //EUR
    var TLV = new Buffer([0x06, 0x29, 0x26, 0x18, 0x0A, 0x02, 0x04, 0x0F, 0x0A, 0x02, 0x06, 0x0F, 0x0A, 0x02, 0x06, 0x1E, 0x0A, 0x02, 0x06, 0xD1, 0x0A, 0x02, 0x06, 0xD3, 0x0A, 0x02, 0x04, 0xFF, 0x12, 0x01, 0x40, 0x1F, 0x04, 0x01, 0xF0, 0x40, 0x01, 0x00, 0x27, 0x03, 0x14, 0x01, 0x01]);
    var buf1 = Buffer.concat([pwbuffer, configbyte, currencycode, servicebyte, TLV]);
    var length = new Buffer([buf1.length]);
    buf = Buffer.concat([buf, length, buf1]);
    return buf;
}

CZVTBankomatHandler.prototype.getDataRegister1 = function (data, error) {
    console.log(data);
    /*if (error) {
    POS.Bankomat.timeout();
    return;

    }*/
    if (data && data.length == 0)
        return;
    //    var defret = jQuery.Deferred();
    var buf = new Buffer([0x80, 0x00, 0x00]);
    var buf1 = new Buffer([0x06, 0x0F]);
    data = new Buffer(data);
    if (POS.Bankomat.Debug) {
        console.log("Receive:");
        console.log(data);
        log.add(1, "Info B-Kasse", 'Receive Registrierungsdaten: ', data.toString('hex'));
    }
    var data1 = data;

    var data2 = data.slice(0, 3);
    if (data2.compare(buf) == 0 && data.length > 3) { //800000 ist vor data
        data = data.slice(3);
        data = data.slice(0, 2);
    } else if (data.length > 3) {
        data = data.slice(0, 2);
    }
    //    var action = POS.Bankomat.authorization;
    if (data.compare(buf1) == 0) {
        clearTimeout(POS.Bankomat.timeoutId);
        //		  POS.hourGlass.hide();
        if (POS.Bankomat.Debug) {
            console.log("Send:");
            console.log(buf);
            log.add(1, "Info B-Kasse", 'Send Schnittselle zur B-Kasse geöffnet', buf.toString('hex'));
        }
        var continueAction = function () {
            switch (POS.Bankomat.action) {
            case "payment":
                POS.Bankomat.authorization();
                break;
            case "printconfig":
                POS.Bankomat.printconfig();
                break;
                /*  case "initialisieren":
                POS.Bankomat.initialize();
                break;
                case "endofday":
                POS.Bankomat.endOfDay();
                break;*/
            case "endofday": //nur damit man terminal-id bekommt
                POS.Bankomat.parseStatusInfo(data1, 3);
                POS.Bankomat.terminalid = POS.Bankomat.transactionstatus[41];
                POS.Bankomat.endOfDay(true);
                break;
            default:
                POS.Bankomat.authorization();
                break;
            }
        }

        POS.Bankomat.client.sendWebsocketData(continueAction, buf, null, null, -1);
        //  defret.resolve(1);
    } else if (data.compare(buf) == 0) {
        //    defret.resolve(1);
    } else if (data.compare(new Buffer([0x00, 0x00, 0x00])) == 0) {
        //    defret.resolve(1);
        POS.Bankomat.reply("fail");
    } else if (error && error == true) {
        //    defret.resolve(1);
        POS.Bankomat.reply("fail");
    } else {
        //      defret.reject(0);
        POS.Bankomat.reply("fail");
    }
    //    return defret.promise();
}
/*
CZVTBankomatHandler.prototype.getDataRegister2 = function(data) {
console.log(data);


var buf1 = new Buffer([0x06, 0x0F]);
var buf = new Buffer([0x80, 0x00, 0x00]);
data = data.slice(0, 2);
console.log("Receive:");
console.log(data);
if (buf1.compare(data) == 0) {
//POS.Bankomat.client.sendWebsocketData(POS.Bankomat.authorization, buf);
POS.Bankomat.authorization();
} else {

}
}*/

CZVTBankomatHandler.prototype.logoff = function () {
    var buf = new Buffer([0x06, 0x02, 0x00]);
    if (POS.Bankomat.Debug) {
        log.add(1, "Info B-Kasse", 'Send Logoff: ', buf.toString('hex'));
        console.log("Send:");
        console.log(buf);
    }
    POS.Bankomat.client.sendWebsocketData(null, buf);
}

CZVTBankomatHandler.prototype.authorization = function () { //payment
    var buf = new Buffer([0x06, 0x01]);
    var sum = new Buffer([0x04]);
    //var timeout = new Buffer([0x01, 0x92]);
    var amount = Math.round(this.amount * 100);
    var amountbyte = new Array(6);
    var newamount = amount;
    for (var i = 0; i < 6; i++) {
        var rest = newamount % 100;
        newamount = Math.round((newamount - rest) / 100);
        amountbyte[i] = "0x" + rest;
    }
    var amount = new Buffer([amountbyte[5], amountbyte[4], amountbyte[3], amountbyte[2], amountbyte[1], amountbyte[0]]);
    //var amount = new Buffer(POS.Bankomat.amount);
    sum = Buffer.concat([sum, amount]);
    //var paymenttype = new Buffer([0x19, 0x50]); //01010000
    var currency = new Buffer([0x49, 0x09, 0x78]); //EUR
    var buf1 = Buffer.concat([sum, currency]);
    var length = new Buffer([buf1.length]);
    buf = Buffer.concat([buf, length, buf1]);
    if (POS.Bankomat.Debug) {
        log.add(1, "Info B-Kasse", 'Send Autorisierungsdaten: ', buf.toString('hex'));
        console.log("Send:");
        console.log(buf);
    }
    POS.Bankomat.timeoutId = setTimeout(
            function () {
            POS.Bankomat.timeout();
        }, 45000);

    POS.Bankomat.client.sendWebsocketData(POS.Bankomat.authorizationreply, buf, null, null, 2);
}

CZVTBankomatHandler.prototype.authorizationreply = function (data) {

    var buf1 = new Buffer([0x80, 0x00, 0x00]);
    var buf2 = new Buffer([0x04, 0x0F]);
    var buf3 = new Buffer([0x06, 0x0F, 0x00]);
    var buf4 = new Buffer([0x06, 0x1E]);
    var buf5 = new Buffer([0x06, 0x30]); //Cancelled
    var buf6 = new Buffer([0x84, 0x83, 0x00]);
    var buf7 = new Buffer([0x00, 0x00, 0x00]);

    var buf = new Buffer([0x04, 0xFF]); //intermediate status -> 0A: Karte einstecken, 0D: Vorgang abgebrochen
    var data1 = new Buffer(data);
    var data2 = data.slice(0, 3);
    if (data2.compare(buf1) == 0 && data.length > 3) { //800000 ist vor data
        data = data.slice(3);
        data = data.slice(0, 2);
    } else if (data.length > 3) {
        data = data.slice(0, 2);
    }
    //    var defret = jQuery.Deferred();
    if (POS.Bankomat.Debug) {
        console.log("Receive:");
        console.log(data1);
        log.add(1, "Info B-Kasse", 'Receive Autorisierungsdatensdaten: ', data1.toString('hex'));
    }
    if (data.compare(buf1) == 0) { //80 00 00
        //      defret.resolve(1);
    } else if (data.compare(buf) == 0) { //intermed status
        if (POS.Bankomat.Debug) {
            log.add(1, "Info B-Kasse", 'Send Autorisierung intermediat: ', buf1.toString('hex'));
            console.log("Send:");
            console.log(buf1);
        }
        POS.Bankomat.client.sendWebsocketData(POS.Bankomat.authorizationreply, buf1);
        //    defret.resolve(1);
    } else if (data.compare(buf2) == 0) { //status  04 0f
        if (POS.Bankomat.Debug) {
            log.add(1, "Info B-Kasse", 'Send Autorisierung status: ', buf1.toString('hex'));
            console.log("Send:");
            console.log(buf1);
        }
        clearTimeout(POS.Bankomat.timeoutId);
        POS.Bankomat.parseStatusInfo(data1);
        POS.Bankomat.client.sendWebsocketData(POS.Bankomat.authorizationreply, buf1);
        //  defret.resolve(1);
    } else if (data.compare(buf3) == 0) { //completed successfully
        if (POS.Bankomat.Debug) {
            log.add(1, "Info B-Kasse", 'Send Autorisierung success: ', buf1.toString('hex'));
            console.log("Send:");
            console.log(buf1);
        }
        POS.hourGlass.hide();
        clearTimeout(POS.Bankomat.timeoutId);
        POS.Bankomat.client.sendWebsocketData(POS.Bankomat.authorizationreply, buf1);
        POS.Bankomat.reply("success");
        //	  POS.Bankomat.client.endWebsocket();
    } else if (data.compare(buf4) == 0 || data.compare(buf5) == 0) { //completed not successfully
        if (POS.Bankomat.Debug) {
            log.add(1, "Info B-Kasse", 'Send Autorisierung no success: ', buf1.toString('hex'));
            console.log("Send:");
            console.log(buf1);
        }
        POS.hourGlass.hide();
        POS.Bankomat.client.sendWebsocketData(POS.Bankomat.authorizationreply, buf1);
        POS.Bankomat.reply("fail");
        clearTimeout(POS.Bankomat.timeoutId);
        //    	  POS.Bankomat.client.endWebsocket();

    } else if (data.compare(buf6) == 0 || data.indexOf('84', 0, 'hex') == 0) { //unknown command or error
        if (POS.Bankomat.Debug) {
            log.add(1, "Info B-Kasse", 'Send Autorisierung command not known: ', buf1.toString('hex'));
            console.log("Send:");
            console.log(buf1);
            POS.hourGlass.hide();
            POS.Bankomat.reply("fail");
            clearTimeout(POS.Bankomat.timeoutId);
            POS.Bankomat.client.sendWebsocketData(null, "endpt");
            return true;
        }
        POS.hourGlass.hide();
        POS.Bankomat.client.sendWebsocketData(POS.Bankomat.authorizationreply, buf1);
        POS.Bankomat.client.sendWebsocketData(null, "endpt");
        clearTimeout(POS.Bankomat.timeoutId);

        //        POS.Bankomat.client.endWebsocket();

    } else {
        if (POS.Bankomat.Debug) {
            log.add(1, "Info B-Kasse", 'Send Autorisierung: ', buf1.toString('hex'));
            console.log("Send:");
            console.log(buf1);
        }
        if (data.compare(buf7) != 0) {
            POS.Bankomat.client.sendWebsocketData(POS.Bankomat.authorizationreply, buf1);
        }
        //defret.resove(1);
    }
    //return defret.promise();
    return true;
}

CZVTBankomatHandler.prototype.printconfig = function () { //payment
    var buf = new Buffer([0x06, 0x1A, 0x00]);
    if (POS.Bankomat.Debug) {
        log.add(1, "Info B-Kasse", 'Sende print config: ', buf.toString('hex'));
        console.log("Send:");
        console.log(buf);
    }
    POS.Bankomat.client.sendWebsocketData(POS.Bankomat.printconfigreply, buf);
}

CZVTBankomatHandler.prototype.printconfigreply = function (data) {
    //var defret = jQuery.Deferred();
    if (POS.Bankomat.Debug) {
        log.add(1, "Info B-Kasse", 'Receive printreply: ', buf1.toString('hex'));
        console.log("Receive:");
        console.log(data);
    }
    var buf1 = new Buffer([0x80, 0x00, 0x00]);
    var buf2 = new Buffer([0x06, 0x0F, 0x00]);
    if (data.compare(buf1) == 0) {
        if (POS.Bankomat.Debug) {
            log.add(1, "Info B-Kasse", 'Send printreply: ', buf1.toString('hex'));
            console.log("Send:");
            console.log(buf1);
        }
        POS.Bankomat.client.sendWebsocketData(POS.Bankomat.printconfigreply, buf1);
    } else if (data.compare(buf2) == 0) { //completed successfully
        //  defret.resolve(1);
    }
    //defret.promise();
}

CZVTBankomatHandler.prototype.parseStatusInfo = function (status, begin) {
    if (!begin) {
        var i = 0;
        while (Number(status[i]) != 0x27) {
            i++;
        }
        begin = i;
        //  begin = 3;
    }
    //this.status_codes[Number(parts[0])] = parts;
    //    for (var i = 0; i < POS.Bankomat.status_codes.length; i++)
    //var stat_code = Number('0x' + POS.Bankomat.status_codes[i][0]);
    var rec_stat_code = Number(status[begin]);

    if (POS.Bankomat.Debug)
        log.add(1, "Info B-Kasse", 'Check: ', rec_stat_code.toString(16));

    if (POS.Bankomat.status_codes.hasOwnProperty(rec_stat_code)) {
        //if (rec_stat_code == stat_code)
        var LLlength = 0;
        if (POS.Bankomat.status_codes[rec_stat_code][1].indexOf('L') == 0) {
            LLlength = POS.Bankomat.status_codes[rec_stat_code][1].length;
            var lengthvalue = status.slice(begin + 1, begin + 1 + LLlength);
            var length = 0;
            for (var x = 0; x < LLlength; x++) {
                length = length * 10 + Number(lengthvalue[x]) - 240;
            }
            //  length = Number('0x' + String(length));
            begin = begin + LLlength;
        } else if (rec_stat_code == 6) { //additional data
            var TLV = status.slice(begin);
            POS.Bankomat.parseTLVInfo(TLV);
            return;
        } else {
            length = Number(POS.Bankomat.status_codes[rec_stat_code][1]);
        }
        var end = begin + length + 1;
        var statusvalue = status.slice(begin + 1, end);
        if (LLlength > 0 && rec_stat_code != 34 && rec_stat_code != 96)
            statusvalue = statusvalue.toString('ascii');
        var transactioninfo = {
            "statuscode": POS.Bankomat.status_codes[rec_stat_code][0],
            "statusvalue": statusvalue,
            "statustext": POS.Bankomat.status_codes[rec_stat_code][2]
        }
        if (POS.Bankomat.Debug) {
            log.add(1, "Info B-Kasse", 'Got: ', POS.Bankomat.status_codes[rec_stat_code][2] + ": " + statusvalue.toString('hex'));
        }
        POS.Bankomat.transactionstatus[rec_stat_code] = transactioninfo;
        POS.Bankomat.parseStatusInfo(status, end);
        //  break;
    }
}

CZVTBankomatHandler.prototype.parseTLVInfo = function (status, begin) {
    if (!begin) {
        if (status[1] == 0b10000001) {
            begin = 3;
        } else if (status[1] == 0b10000010) {
            begin = 4;
        } else {
            begin = 2;
        }
    }

    //this.status_codes[Number(parts[0])] = parts;
    //    for (var i = 0; i < POS.Bankomat.status_codes.length; i++)
    //var stat_code = Number('0x' + POS.Bankomat.status_codes[i][0]);
    var rec_stat_code = Number(status[begin]);

    if (rec_stat_code == 0x1F) {
        rec_stat_code = Number(status[begin]) * 256 + Number(status[begin + 1]);
        begin = begin + 1;
    }

    if (POS.Bankomat.Debug)
        log.add(1, "Info B-Kasse", 'Check: ', rec_stat_code);

    if (POS.Bankomat.TLV_container.hasOwnProperty(rec_stat_code)) {
        length = Number(status[begin + 1]);
        var end = begin + length + 2;

        switch (rec_stat_code) {
        case 0x2F:
            end = begin + 2;
            //    POS.Bankomat.parseTLVInfo(status, end);
            break;
        case 0x1F10:
            var statusvalue = status.slice(begin + 2, end);
            if (POS.Bankomat.Debug) {
                log.add(1, "Info B-Kasse", 'Got: ', POS.Bankomat.TLV_container[rec_stat_code][1] + ": " + statusvalue.toString('hex'));
            }
            var transactioninfo = {
                "statuscode": POS.Bankomat.TLV_container[rec_stat_code][0],
                "statusvalue": statusvalue,
                "statustext": POS.Bankomat.TLV_container[rec_stat_code][1]
            }
            if (POS.Bankomat.transactionstatus)
                POS.Bankomat.transactionstatus[rec_stat_code] = transactioninfo;
            //POS.Bankomat.parseTLVInfo(status, end);
            break;
        case 0x1F12:
            var statusvalue = status.slice(begin + 2, end);
            if (POS.Bankomat.Debug) {
                log.add(1, "Info B-Kasse", 'Got: ', POS.Bankomat.TLV_container[rec_stat_code][1] + ": " + statusvalue.toString('hex'));
            }
            var transactioninfo = {
                "statuscode": POS.Bankomat.TLV_container[rec_stat_code][0],
                "statusvalue": statusvalue,
                "statustext": POS.Bankomat.TLV_container[rec_stat_code][1]
            }
            if (POS.Bankomat.transactionstatus)
                POS.Bankomat.transactionstatus[rec_stat_code] = transactioninfo;
            //POS.Bankomat.parseTLVInfo(status, end);
            break;
        }
        POS.Bankomat.parseTLVInfo(status, end);
        //  break;
    } else {
        length = Number(status[begin + 1]);
        var end = begin + length + 2;
        if (end < status.length) {
            POS.Bankomat.parseTLVInfo(status, end);
        }
    }
}

CZVTBankomatHandler.prototype.endOfDay = function (connected) {

    POS.Bankomat.transactionstatus = [];
    //   var buf = new Buffer([0x06, 0x50, 0x03, 0x28, 0x00, 0x11]);

    var buf = new Buffer([0x06, 0x50, 0x03, 0x00, 0x00, 0x00]);
    if (POS.Bankomat.Debug) {
        log.add(1, "Info B-Kasse", 'Send End of Day: ', buf.toString('hex'));
        console.log("Send:");
        console.log(buf);
    }
    if (connected) {
        POS.Bankomat.client.sendWebsocketData(POS.Bankomat.endOfDayReply, buf);
    } else {
        POS.Bankomat.client.sendWebsocketData(POS.Bankomat.endOfDayReply, buf);
    }
}

CZVTBankomatHandler.prototype.endOfDayReply = function (data) {
    var buf1 = new Buffer([0x80, 0x00, 0x00]);
    var buf2 = new Buffer([0x04, 0x0F]);
    var buf3 = new Buffer([0x06, 0x0F, 0x00]);
    var buf4 = new Buffer([0x06, 0x1E]);
    var buf5 = new Buffer([0x84, 0x83, 0x00]);
    var buf6 = new Buffer([0x00, 0x00, 0x00]);
    var buf = new Buffer([0x04, 0xFF]); //intermediate status -> 0A: Karte einstecken, 0D: Vorgang abgebrochen
    var data1 = new Buffer(data);
    if (data.length > 3) {
        data = data.slice(0, 2);
    }
    //    var defret = jQuery.Deferred();
    if (POS.Bankomat.Debug) {
        console.log("Receive:");
        console.log(data1);
        log.add(1, "Info B-Kasse", 'Receive End Of Day: ', data1.toString('hex'));
    }
    if (data.compare(buf1) == 0) {
        //      defret.resolve(1);
    } else if (data.compare(buf) == 0) { //intermed status
        if (POS.Bankomat.Debug) {
            log.add(1, "Info B-Kasse", 'Send End Of Day intermediat: ', buf1.toString('hex'));
            console.log("Send:");
            console.log(buf1);
        }
        POS.Bankomat.client.sendWebsocketData(POS.Bankomat.endOfDayReply, buf1);
        //    defret.resolve(1);
    } else if (data.compare(buf2) == 0) { //status
        if (POS.Bankomat.Debug) {
            log.add(1, "Info B-Kasse", 'Send End Of Day status: ', buf1.toString('hex'));
            console.log("Send:");
            console.log(buf1);
        }
        POS.Bankomat.parseStatusInfo(data1);
        POS.Bankomat.client.sendWebsocketData(POS.Bankomat.endOfDayReply, buf1);
        //  defret.resolve(1);
    } else if (data.compare(buf3) == 0) { //completed successfully
        if (POS.Bankomat.Debug) {
            log.add(1, "Info B-Kasse", 'Send End Of Day success: ', buf1.toString('hex'));
            console.log("Send:");
            console.log(buf1);
        }
        POS.Bankomat.client.sendWebsocketData(POS.Bankomat.endOfDayReply, buf1);
        POS.Bankomat.cardBalanceFinish();
        //POS.Bankomat.client.client.end();
        //POS.Bankomat.logoff();
        //defret.resolve(1);
    } else if ((data.compare(buf4) == 0) || (data.compare(buf6) == 0)) { //completed not successfully
        if (POS.Bankomat.Debug) {
            log.add(1, "Info B-Kasse", 'Send End Of Day no success: ', buf1.toString('hex'));
            console.log("Send:");
            console.log(buf1);
            POS.Bankomat.client.sendWebsocketData(null, 'endpt');

            //POS.Bankomat.client.client.end();
        }
        POS.Bankomat.client.sendWebsocketData(POS.Bankomat.endOfDayReply, buf1);
        POS.Bankomat.reply("fail");
        //defret.reject(0);
    } else if (data.compare(buf5) == 0) { //command not known
        POS.Bankomat.reply("fail");
        //POS.Bankomat.client.client.end();
        //defret.reject(0);
    } else {
        if (POS.Bankomat.Debug) {
            log.add(1, "Info B-Kasse", 'Send End Of Day: ', buf1.toString('hex'));
            console.log("Send:");
            console.log(buf1);
        }
        var lastbytes = Buffer.from(data.buffer,data.buffer.byteLength-3,3);
        if ((lastbytes.compare(buf3) == 0) || (lastbytes.compare(buf4) == 0) || (lastbytes.compare(buf6) == 0)) {
            POS.Bankomat.endOfDayReply(lastbytes);
        } else {
            POS.Bankomat.client.sendWebsocketData(POS.Bankomat.endOfDayReply, buf1);
        }
        //defret.resove(1);
    }
    //return defret.promise();
    return true;
}

CZVTBankomatHandler.prototype.printconfig = function () { //payment
    var buf = new Buffer([0x06, 0x1A, 0x00]);
    if (POS.Bankomat.Debug) {
        log.add(1, "Info B-Kasse", 'Sende print config: ', buf.toString('hex'));
        console.log("Send:");
        console.log(buf);
    }
    POS.Bankomat.client.sendWebsocketData(POS.Bankomat.printconfigreply, buf);
}

CZVTBankomatHandler.prototype.printconfigreply = function (data) {
    //var defret = jQuery.Deferred();
    if (POS.Bankomat.Debug) {
        log.add(1, "Info B-Kasse", 'Receive printreply: ', buf1.toString('hex'));
        console.log("Receive:");
        console.log(data);
    }
    var buf1 = new Buffer([0x80, 0x00, 0x00]);
    var buf2 = new Buffer([0x06, 0x0F, 0x00]);
    if (data.compare(buf1) == 0) {
        if (POS.Bankomat.Debug) {
            log.add(1, "Info B-Kasse", 'Send printreply: ', buf1.toString('hex'));
            console.log("Send:");
            console.log(buf1);
        }
        POS.Bankomat.client.sendWebsocketData(POS.Bankomat.printconfigreply, buf1);
    } else if (data.compare(buf2) == 0) { //completed successfully
        //  defret.resolve(1);
    }
    //defret.promise();
}
/*
CZVTBankomatHandler.prototype.parseStatusInfo = function(status, begin) {
if (!begin) {
begin = 3;
}
for (var i = 0; i < POS.Bankomat.status_codes.length; i++) {
var stat_code = Number('0x' + POS.Bankomat.status_codes[i][0]);
var rec_stat_code = Number(status[begin]);
if (rec_stat_code == stat_code) {
var LLlength = 0;
if (POS.Bankomat.status_codes[i][1].indexOf('L') == 0) {
LLlength = POS.Bankomat.status_codes[i][1].length;
var lengthvalue = status.slice(begin + 1, begin + 1 + LLlength);
var length = 0;
for (var x = 0; x < LLlength; x++) {
length = length * 10 + Number(lengthvalue[x]) - 240;
}
begin = begin + LLlength;
} else {
length = Number(POS.Bankomat.status_codes[i][1]);
}
var end = begin + length + 1;
var statusvalue = status.slice(begin + 1, end);
if (LLlength > 0 && stat_code != 34) statusvalue = statusvalue.toString('ascii');
var transactioninfo = {
"statuscode": POS.Bankomat.status_codes[i][0],
"statusvalue": statusvalue,
"statustext": POS.Bankomat.status_codes[i][2]
}
if (POS.Bankomat.Debug) {
log.add(1, "Info B-Kasse", 'Got: ', stat_code + ":" + POS.Bankomat.status_codes[i][2] + ": " + statusvalue.toString('hex'));
}
POS.Bankomat.transactionstatus.push(transactioninfo);
POS.Bankomat.parseStatusInfo(status, end);
break;
}
}
}
 */
CZVTBankomatHandler.prototype.initializationreply = function (data) {
    //var defret = jQuery.Deferred();
    console.log(data);
    console.log("Receive:");
    console.log(data);
    var buf1 = new Buffer([0x80, 0x00, 0x00]);
    var buf2 = new Buffer([0x06, 0x0F, 0x00]);
    if (data.compare(buf1) == 0) {
        defret.resolve(1);
        console.log("Send:");
        console.log(buf1);
        POS.Bankomat.client.sendWebsocketData(POS.Bankomat.initializationreply, buf1);
        //  defret.resolve(1);
    } else if (data.compare(buf2) == 0) { //completed successfully
        console.log("Send:");
        console.log(buf1);
        POS.Bankomat.client.sendWebsocketData(POS.Bankomat.initializationreply, buf1);
        //defret.resolve(1);
    } else {
        console.log("Send:");
        console.log(buf1);
        POS.Bankomat.client.sendWebsocketData(POS.Bankomat.initializationreply, buf1);
        //defret.resolve(1);
    }
    //defret.promise();
}

CZVTBankomatHandler.prototype.reply = function (data) {

    POS.Bankomat.client.sendWebsocketData(null, "endpt");

    switch (data) {
    case "success":
        var needsignature = false;
        var resultText = "undefinierte Nachricht";
        var source = "-1";
        if (POS.Bankomat.transactionstatus && POS.Bankomat.transactionstatus[0x1F10]) {
            var cardholder_authentication = POS.Bankomat.transactionstatus[0x1F10].statusvalue[0];
            if (cardholder_authentication == 1 || cardholder_authentication == 7) {
                needsignature = true;
                POS.Bankomat.isDebitBuy = false; //dann Kreditkarte
                var voucher = new CCreditCardVoucher();
            } else {
                var voucher = new CDebitVoucher();
            }
        } else {
            var voucher = new CDebitVoucher();
        }

        for (rec_stat_code in POS.Bankomat.transactionstatus) {

            switch (rec_stat_code) {
                /* case 0x1F10:
                var cardholder_authentication = POS.Bankomat.transactionstatus[0x1F10].statusvalue[0];
                if (cardholder_authentication == 1 || cardholder_authentication == 7) {
                needsignature = true;
                POS.Bankomat.isDebitBuy = false; //dann Kreditkarte
                }
                break;*/
            case 0x3C:
                voucher.resultText = POS.Bankomat.transactionstatus[0x3C].statusvalue.toString('ascii').split("/")[0]; //"Bezahlt";
                break;
            case 0x04:
                voucher.amount = cent2Euro(Number(POS.Bankomat.transactionstatus[0x04].statusvalue.toString('hex')));
                break;
            case 0x8B:
                voucher.ccc = POS.Bankomat.transactionstatus[0x8B].statusvalue.toString('ascii');
                break;
            case 0x22:
                voucher.creditCardNo = POS.Bankomat.transactionstatus[0x22].statusvalue.slice(6);
                voucher.creditCardNo = "**** **** **** " + voucher.creditCardNo.toString('hex');
                break;
            case 0x0E:
                voucher.expiration = POS.Bankomat.transactionstatus[0x0E].statusvalue.toString('hex');
                voucher.expiration = voucher.expiration.substring(2) + "/" + voucher.expiration.substring(0, 2);
                break;
            case 0x1F12:
                voucher.source = POS.Bankomat.transactionstatus[0x1F12].statusvalue[0]; //"source"; //message.charAt(51)
                break;
            case 0x0B:
                voucher.traderNo = POS.Bankomat.transactionstatus[0x0B].statusvalue.toString('hex'); // trace-no ="tradernumebr"??; //message.substr(52, 16);
                break;
            case 0x29:
                voucher.terminalId = POS.Bankomat.transactionstatus[0x29].statusvalue.toString('hex'); //POS.Bankomat.terminalid;
                break;
            case 0x87:
                voucher.voucherNo = Number(POS.Bankomat.transactionstatus[0x87].statusvalue.toString('hex')); //receipt-nr
                break;
            case 0x3B:
                voucher.acceptanceNo = POS.Bankomat.transactionstatus[0x3B].statusvalue.toString('ascii');
                break;

            }

        }

        if (POS.Bankomat.isDebitBuy) {
            POS.Bankomat.isCreditBuy = false;
            POS.Bankomat.isDebitBuy = false;
            POS.Bankomat.messageText = voucher.resultText;
            POS.Bankomat.messageText += "\nEUR " + voucher.amount;
            POS.Bankomat.answerComp.onDebitCardTransaction(
                POS.Bankomat.answerComp,
                POS.Bankomat.messageText, voucher);
        } else { //creditcard
            POS.Bankomat.isDebitBuy = false;
            POS.Bankomat.isCreditBuy = false;
            POS.Bankomat.answerComp.Main.BonManager.printMode = "bill";
            voucher.refAmount = "";
            voucher.refVoucher = null; //"refVoucher"; //message.substr(124, 6);
            ///////////////////////
            voucher.signature = needsignature;
            POS.Bankomat.isCopy = false;
            POS.Bankomat.messageText = "message-text";
            // Left transactions
            // Print salesman voucher for customer's signature
            if (needsignature) {
                $.when(voucher.print()).done(function () {
                    if (typeof POS.Bankomat.answerComp.onCreditCardTransaction == "function") {
                        POS.Bankomat.answerComp.onCreditCardTransaction(
                            POS.Bankomat.answerComp,
                            POS.Bankomat.messageText,
                            voucher);
                    }
                });
            } else {
                if (typeof POS.Bankomat.answerComp.onCreditCardTransaction == "function") {
                    POS.Bankomat.answerComp.onCreditCardTransaction(
                        POS.Bankomat.answerComp,
                        POS.Bankomat.messageText,
                        voucher);
                }
            }
            POS.Bankomat.isCopy = false;
        }

        break;
    default:
        POS.Bankomat.messageText = "KEIN ERGEBNIS!";
        POS.Bankomat.sendDisplayMessage(POS.Bankomat.messageText);
        POS.Bankomat.answerComp.onCancelTransaction(
            POS.Bankomat.answerComp,
            POS.Bankomat.messageText);
        break;
    }
}

CZVTBankomatHandler.prototype.sendDisplayMessage = function (message) {

    try {
        expr = /\n/;
        messages = message.split(expr);
        POS.Bankomat.Display.addLine();
        POS.Bankomat.Display.addElement(messages[0], 0, 0, 0, 19);
        POS.Bankomat.Display.addLine();
        if (messages.length > 1)
            POS.Bankomat.Display.addElement(messages[1], 19, 1, 0, 19);
        else
            POS.Bankomat.Display.addElement("", 9, 2, 0, 19);
        POS.Bankomat.Display.out();
    } catch (e) {}
}

CZVTBankomatHandler.prototype.buyDebit = function (amount, bonId, answerComp) {
    POS.Bankomat.isDebitBuy = true;
    POS.Bankomat.isCreditBuy = false;
    POS.Bankomat.answerComp = answerComp;
    amount = parseFloat(amount);
    POS.Bankomat.setAction("", amount);
    POS.Bankomat.registration();
}

CZVTBankomatHandler.prototype.buyDebitCallBack = function (amount, bonId, answerComp) {}

CZVTBankomatHandler.prototype.buyCredit = function (amount, bonId, answerComp) {
    POS.Bankomat.isCreditBuy = true;
    POS.Bankomat.isDebitBuy = false;
    POS.Bankomat.answerComp = answerComp;
    amount = parseFloat(amount);
    POS.Bankomat.setAction("", amount);
    POS.Bankomat.registration();
}

CZVTBankomatHandler.prototype.buyCreditCallBack = function (amount, bonId, answerComp) {
    POS.Bankomat.isCreditBuy = true;
    POS.Bankomat.isDebitBuy = false;
    POS.Bankomat.answerComp = answerComp;
    amount = parseFloat(amount);
    POS.Bankomat.setAction("", amount);
    POS.Bankomat.registration();
}

CZVTBankomatHandler.prototype.creditAdvice = function (amount, bonId, answerComp) {
    var BankomatClass = this;
    this.answerComp = answerComp;

}

CZVTBankomatHandler.prototype.creditAdviceCallback = function (params) {
    if (params.length == 3) {
        POS.Bankomat.creditAdvice(params[0], params[1], params[2]);
        return;
    }

    POS.Bankomat.dumpCallback("creditAdvice");
}

CZVTBankomatHandler.prototype.resendVoucher = function (answerComp) {
    POS.Bankomat.answerComp = answerComp;
}

CZVTBankomatHandler.prototype.cardBalance = function (answerComp, tksum) {
    var BankomatClass = POS.Bankomat;
    POS.Bankomat.answerComp = answerComp;
    POS.Bankomat.tkSum = tksum;
    POS.Bankomat.setAction("endofday");
    POS.Bankomat.registration();

    //POS.Bankomat.endOfDay();
}

CZVTBankomatHandler.prototype.cardBalanceFinish = function () {

    // normal nach reply
    var voucher = new CCreditBalanceVoucher();
    voucher.terminalId = POS.Bankomat.terminalid; //POS.Bankomat.transactionstatus[41];
    voucher.czId = "ciID"; //POS.Bankomat.transactionstatus[];


    voucher.bargainText = "Erhalten";
    voucher.cancelText = "Storniert";
    voucher.adviceText = "Gutgeschrieben";

    POS.Bankomat.client.sendWebsocketData(null, 'endpt');
    //neu
    POS.Bankomat.messageText = "Kassenschnitt erfolgreich";
    //var totalamount = Number(POS.Bankomat.transactionstatus[4].statusvalue.toString('hex')) / 100;
    voucher.rowSetCount = 1;
    var cards = ["Alle Karten"];

    /*
    voucher.rowSetCount = 7;
    var cards = ["Girocard (Debitcards)", "JCB", "Mastercard", "Amex", "Visa", "Diners", "Andere"];
    var amounts = POS.Bankomat.transactionstatus[96].statusvalue;
    //var totalamount = POS.Bankomat.parseBCD(POS.Bankomat.transactionstatus[4].statusvalue) / 100;

    var begin = 4;
     */
    ////////////
    var vr = "T-K:";
    var sign = " ";
    if (POS.Bankomat.tkSum < 0)
        sign = "-";

    POS.Bankomat.tkSum = Math.abs(parseFloat(POS.Bankomat.tkSum));
    POS.Bankomat.tkSum = float2StringD2(POS.Bankomat.tkSum);

    vr += sign;
    vr += prepareFixedLength(11, " ", POS.Bankomat.tkSum);
    vr += "           TES-Kasse";

    /////////////
    /*
    for (var i = 0; i < voucher.rowSetCount; i++) {
    var dataSet = new CBalanceDataSet();
    var cardnr = amounts.slice(begin, begin + 1);
    var cardamount = amounts.slice(begin + 1, begin + 7);
    dataSet.rowSetNo = String(i);
    dataSet.ccc = cards[i];
    dataSet.traderNo = "traderno";
    dataSet.resultText = "";
    if (i == 0) {
    dataSet.resultText = vr;
    }
    //      dataSet.sum = POS.Bankomat.parseBCD(cardamount) / 100;
    dataSet.sum = Number(cardamount.toString('hex')) / 100;
    dataSet.accountsDate = POS.Bankomat.transactionstatus[0x0D].statusvalue.toString('hex');
    dataSet.accountsTime = POS.Bankomat.transactionstatus[0x0C].statusvalue.toString('hex');
    dataSet.sumSign = "+";
    voucher.dataSets.push(dataSet);
    begin = begin + 7;
    }
     */

    var dataSet = new CBalanceDataSet();
    var cardnr = 0;
    var cardamount = POS.Bankomat.transactionstatus[4].statusvalue;
    dataSet.rowSetNo = "0";
    dataSet.ccc = cards[0];
    dataSet.traderNo = "traderno";
    dataSet.resultText = "";
    // if (i == 0) {
    dataSet.resultText = vr;
    //   }
    //      dataSet.sum = POS.Bankomat.parseBCD(cardamount) / 100;
    dataSet.sum = Number(cardamount.toString('hex')) / 100;
    var date = new Date();
    dataSet.accountsDate =
        ("00" + (date.getMonth() + 1)).slice(-2) +
    ("00" + date.getDate()).slice(-2);
    dataSet.accountsTime =
        ("00" + date.getHours()).slice(-2) +
    ("00" + date.getMinutes()).slice(-2) +
    ("00" + date.getSeconds()).slice(-2);
    dataSet.sumSign = "+";
    voucher.dataSets.push(dataSet);

    $.when(voucher.print()).done(function () {
        POS.Bankomat.answerComp.onCardBalance(POS.Bankomat.answerComp,
            POS.Bankomat.messageText,
            voucher);
    });

}

CZVTBankomatHandler.prototype.parseBCD = function (BCDBytes, isString) {

    var num = 0;
    for (var i = BCDBytes.length - 1; i < 0; i--) {
        num = num * 100;
        var b = BCDBytes[i].toString('hex');
        num = num + Number(b);
    }
    return num;
}

CZVTBankomatHandler.prototype.creditCardBalanceCallback = function (answerComp) {
    if (typeof answerComp != "string") {
        POS.Bankomat.dumpCallback("creditCardBalance");
        return;
    }

    POS.Bankomat.creditCardBalance(answerComp);
}

CZVTBankomatHandler.prototype.debitCardBalance = function (answerComp) {

    POS.Bankomat.answerComp = answerComp;

    voucher = new CDebitBalanceVoucher();
    voucher.sum = 0; // parseFloat(remEuropeanComma(message.substr(8, 12)));
    /*voucher.result = message.substr(4, 40);
    voucher.messageText = message.substr(44, 16);*/
    var vr = "T-K:";
    var sign = " ";
    if (POS.Bankomat.tkSum < 0)
        sign = "-";

    POS.Bankomat.tkSum = Math.abs(parseFloat(POS.Bankomat.tkSum));
    POS.Bankomat.tkSum = float2StringD2(POS.Bankomat.tkSum);

    vr += sign;
    vr += prepareFixedLength(11, " ", POS.Bankomat.tkSum);
    vr += "           TES-Kasse";

    voucher.voucherRows.push(vr);

    //  me.messageText = message.substr(44, 16);

    $.when(voucher.print(true)).done(function () {
        POS.Bankomat.tkSum = 0;
        POS.Bankomat.answerComp.onDebitCardBalance(
            POS.Bankomat.answerComp,
            POS.Bankomat.messageText, voucher);
    });
}

CZVTBankomatHandler.prototype.debitCardBalanceCallback = function (answerComp) {
    if (typeof answerComp != "string") {
        POS.Bankomat.dumpCallback("debitCardBalance");
        return;
    }

    POS.Bankomat.debitCardBalance(answerComp);
}

CZVTBankomatHandler.prototype.reversal = function (amount, voucherNo, answerComp) {

    POS.Bankomat.answerComp = answerComp;
    amount = parseFloat(amount);

    var buf = new Buffer([0x06, 0x30]);
    var voucher = ("00" + String(voucherNo)).substr(-4);
    var part1 = '0x' + voucher.slice(0, 2);
    var part2 = '0x' + voucher.slice(2, 4);
    //var receiptnr = new Buffer([part1,part2));
    var receiptnr = new Buffer(['0x87', part1, part2]);
    var buf1 = new Buffer([0x28, 0x00, 0x11]); //PW
    buf1 = Buffer.concat([buf1, receiptnr]);
    var length = new Buffer([buf1.length]);
    buf = Buffer.concat([buf, length, buf1]);
    //var buf = new Buffer([0x06, 0x50, 0x00]);
    if (POS.Bankomat.Debug) {
        log.add(1, "Info B-Kasse", 'Send Reversal: ', voucherNo);
        console.log("Send:");
        console.log(buf);
    }
    POS.Bankomat.client.sendWebsocketData(POS.Bankomat.authorizationreply, buf);
}

CZVTBankomatHandler.prototype.cancellation = function (amount, voucherNo, answerComp) {

    POS.Bankomat.answerComp = answerComp;
    POS.Bankomat.reply("fail");
    clearTimeout(POS.Bankomat.timeoutId);
    POS.hourGlass.hide();
    /*
    var buf = new Buffer([0x06, 0x30]);
    var voucher = ("00" + String(voucherNo)).substr(-4);
    var part1 = '0x' + voucher.slice(0, 2);
    var part2 = '0x' + voucher.slice(2, 4);
    //var receiptnr = new Buffer([part1,part2));
    var receiptnr = new Buffer(['0x87', part1, part2]);
    var buf1 = new Buffer([0x28, 0x00, 0x11]); //PW
    buf1 = Buffer.concat([buf1, receiptnr]);
    var length = new Buffer([buf1.length]);
    buf = Buffer.concat([buf, length, buf1]);
    //var buf = new Buffer([0x06, 0x50, 0x00]);
    if (POS.Bankomat.Debug) {
    log.add(1, "Info B-Kasse", 'Send Reversal: ', voucherNo);
    console.log("Send:");
    console.log(buf);
    }*/
}

//@ sourceURL=CLS_CZVTBankomat.js

export { CZVTBankomatHandler };
